import { IonItem } from '@ionic/react';
import { FullAdminAction, calcDateSpanDescription } from 'model';
// eslint-disable-next-line css-modules/no-unused-class
import shareStyles from '../../styles/Shared.module.css';
import { ProfilePic } from '../ProfilePic';
import styles from './ReportItem.module.css';

import { IconChatbox, IconEdit, IconReport } from '../QuirkIcons';

export const AdminReportItem: React.FC<{ item: FullAdminAction; openModal: () => void }> = ({ item, openModal }) => {
	return (
		<>
			<IonItem className={styles.ionItem}>
				<div
					className={styles.reportItemContainer}
					data-testid={`ReportItem-${item.user._id}-${item.document}`}
					onClick={openModal}
				>
					<div className={shareStyles.authorHeader}>
						<div className={styles.iconContainer}>
							{item.documentType === 'post' ? <IconEdit /> : <IconChatbox />}
						</div>
						<>
							<ProfilePic user={item.user} />
							<div>
								<div className={shareStyles.name}>{item.user.username}</div>
								<div>
									<span className={shareStyles.time}>
										{calcDateSpanDescription(new Date(item.created).toISOString())}
									</span>
								</div>
							</div>
						</>
					</div>
					<div className={styles.flagCountContainer}>
						<span>{item.totalReports}</span>
						<IconReport />
					</div>
				</div>
			</IonItem>
		</>
	);
};
